/* Tools grid icons for the About page */
import macOs from "../Assets/TechIcons/Apple MacOSX.svg";
import chrome from "../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../Assets/TechIcons/vscode.svg";
import Windows from "../Assets/TechIcons/Windows.svg";
import Workspace from "../Assets/TechIcons/GoogleWorkspace.svg";
import Claude from "../Assets/TechIcons/Claude.svg";
import n8n from "../Assets/TechIcons/n8n.svg";
import Rhino from "../Assets/TechIcons/Rhino 8.svg";
import Supabase from "../Assets/TechIcons/Supabase.png";
import Vercel from "../Assets/TechIcons/Vercel.svg";
import Sentry from "../Assets/TechIcons/sentry.svg";
import Jupyter from "../Assets/TechIcons/jupyter.svg";
import SolidWorks from "../Assets/TechIcons/solidworks.svg";

export const toolIcons = [
    { icon: Windows, alt: "Windows", label: "Windows" },
    { icon: macOs, alt: "macOs", label: "Mac Os" },
    { icon: chrome, alt: "Chrome", label: "Google Chrome" },
    { icon: Workspace, alt: "Workspace", label: "Google Workspace" },
    { icon: Claude, alt: "Claude", label: "Claude" },
    { icon: vsCode, alt: "vsCode", label: "Vs Code" },
    { icon: Jupyter, alt: "Jupyter", label: "Jupyter Lab" },
    { icon: n8n, alt: "n8n", label: "n8n" },
    { icon: Rhino, alt: "Rhino", label: "Rhino 8" },
    { icon: SolidWorks, alt: "SolidWorks", label: "SolidWorks" },
    { icon: Vercel, alt: "Vercel", label: "Vercel" },
    { icon: Supabase, alt: "Supabase", label: "Supabase" },
    { icon: Sentry, alt: "Sentry", label: "Sentry" },
];
